const comprobante = {
  readComprobanteTipos: 'comprobantes-tipo/{{pais}}',
  readComprobante: 'comprobante/{{uuid_comprobante}}',
  readComprobanteByPago: 'comprobante/pago/{{uuid_pago}}',
  readComprobantePdf: 'comprobante/{{uuid}}/pdf',
  readComprobantesByPuntoVenta: 'comprobantes/{{uuid_academia}}',
  readExportarComprobantesByPuntosVenta: 'comprobantes/{{uuid_academia}}/exportar',
  solicitarZip: 'comprobantes/{uuid_academia}/solicitar-zip'
}

export default comprobante
